export default __webpack_public_path__ + "static/media/6.ESSENTIALDRUGSCOMPANYLIMITED,Bogra.06809bf0.jpg";